import { type SvgIconProps } from "@mui/material/SvgIcon";
import { type FC } from "react";

export enum IndicesTabEnum {
  WAR = "war",
}

export const labelByIndicesTabEnum: Record<IndicesTabEnum, string> = {
  [IndicesTabEnum.WAR]: "War Index",
};

export const iconByIndicesTabEnum: Record<
  IndicesTabEnum,
  FC<SvgIconProps> | null
> = {
  [IndicesTabEnum.WAR]: null,
};
